module.exports = __webpack_public_path__ + "static/media/more-all-products-4.fb897af1.png";